import { GenerateInvoice } from "../components/GenerateInvoice";

export const GenerateInvoicePage = () => {
  return <GenerateInvoice />;
};
